import React from 'react';
import { Modal, Button, Form, Input, Icon, Tabs } from 'antd';

import ReferenciasVinculado from './ViewModal/ReferenciasVinculado';

const InputGroup = Input.Group;
const { TabPane } = Tabs;

export default class ViewModal extends React.Component {
    render() {
        return (
            <Modal
                title={"Comprobante"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                style={{ top: 30 }}
                width={800}
                footer={[
                    <Button
                        key="1"
                        onClick={this.props.onClose}
                    >
                        Cerrar
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-4">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '65%' }}
                                        value={this.props.formValues.fechaStr}
                                        suffix={<Icon type="calendar" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                    />
                                    <Input readOnly
                                        style={{ width: '35%' }}
                                        value={this.props.formValues.tipoCambio}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '40%' }}
                                        value={this.props.formValues.serie}
                                    />
                                    <Input readOnly
                                        style={{ width: '60%' }}
                                        value={this.props.formValues.documento}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Días / Fecha de Vencimiento">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '35%' }}
                                        value={this.props.formValues.diasVencimiento}
                                    />
                                    <Input readOnly
                                        style={{ width: '65%' }}
                                        value={this.props.formValues.fechaVencimientoStr}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
           
                    </div>
            
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs>
                                <TabPane tab="Documentos Vinculados" key="2">
                                    <ReferenciasVinculado
                                        dataSource={this.props.formValues.referencias}
                                        />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                
                </Form>
            </Modal>
        );
    }
}